//用电高级功能
export default [
	{
	//设备排名
	path:'/energyRanking',
	name:'energyRanking',
	component:() => import('@/page/energy/EnergyRanking.vue')
	},
	{
	//尖峰平谷
	path: '/energy',
	name: 'energy',
	component: () => import('@/page/energy/energy.vue')
	// component: () => import('@/page/abbNewPage/EnterpriseBasicDatadata.vue')
}, {
	path: '/energySaving',//节能评估
	name: 'energySaving',
	component: () => import('@/page/energy/energySaving.vue')
}, {
	path: '/usePowerDifference',//能源消耗
	name: 'usePowerDifference',
	component: () => import('@/page/energy/usePowerDifference.vue')
},{
	path: '/newusePowerDifference',//能源消耗(新)
	name: 'newusePowerDifference',
	component: () => import('@/page/energy/newusePowerDifference.vue')
},
	{
		path: '/areaPowerDifference',//能源消耗
		name: 'areaPowerDifference',
		component: () => import('@/page/energy/areaPowerDifference.vue')
	},
	{
	//实时电能质量
	path: '/realPowerQuality',
	name: 'realPowerQuality',
	component: () => import('@/page/powerQuality/realPowerQuality.vue')
}, {
	path: '/dayPowerQuality',
	name: 'dayPowerQuality',
	component: () => import('@/page/powerQuality/dayPowerQuality.vue')
}, {
	path: '/weekPowerQuality',
	name: 'weekPowerQuality',
	component: () => import('@/page/powerQuality/weekPowerQuality.vue')
}, {
	path: '/monthPowerQuality',
	name: 'monthPowerQuality',
	component: () => import('@/page/powerQuality/monthPowerQuality.vue')
}, {
	path: '/quarterPowerQuality',
	name: 'quarterPowerQuality',
	component: () => import('@/page/powerQuality/quarterPowerQuality.vue')
}, {
	path: '/yearPowerQuality',
	name: 'yearPowerQuality',
	component: () => import('@/page/powerQuality/yearPowerQuality.vue')
}, {
	//需量
	path: '/demandProp',
	name: 'demandProp',
	component: () => import('@/page/demand/demandProp.vue')
}, {
	path: '/demandRTCurve',//实时需量
	name: 'demandRTCurve',
	component: () => import('@/page/demand/demandRTCurve.vue')
}, {
	path: '/demand',//需量曲线
	name: 'demand',
	component: () => import('@/page/demand/demand.vue')
}, {
	 path: '/usePowerCalendar',//用电日历
	 name: 'usePowerCalendar',
	 component: () => import('@/page/energy/usePowerCalendar.vue')
},{
     path: '/usePowerCalendarEdit',//用电日历阈值设置
	 name: 'usePowerCalendarEdit',
	component: () => import('@/page/energy/usePowerCalendarEdit.vue')
  },{
	 path: '/realitySimulation',//仿真
	 name: 'realitySimulation',
	component: () => import('@/page/energy/realitySimulation.vue')
},{
	path: '/BIVisualization',//数据大屏
	name: 'BIVisualization',
   component: () => import('@/page/energy/BIVisualization.vue')
},{
	path: '/videoSurveillance',//视频监控
	name: 'videoSurveillance',
   component: () => import('@/page/energy/videoSurveillance.vue')
},{
	path: '/workingConditionChart',//工况图
	name: 'workingConditionChart',
   component: () => import('@/page/energy/workingConditionChart.vue')
}



	
	]
